
import { instantiate } from './composeApp.uninstantiated.mjs';
export default (await instantiate()).exports;
